<template>
  <section class="all-cases-view" v-loading="loading">
    <div class="primary-content-view-new" v-if="adminsData">
      <div class="listings listings__table listings__all-cases">
        <el-table :data="adminsData.data">
          <el-table-column
            label="Username"
            width="165"
            prop="username"
            fixed
            sortable="custom"
          >
          </el-table-column>
          <el-table-column label="First Name" width="165" prop="first_name">
            <template v-slot="scope">
            {{
                scope.row.first_name
                  ? convertToUppercase(scope.row.first_name)
                  : "--"
            }}
            </template>
          </el-table-column>
          <el-table-column label="Last Name" width="165" prop="last_name">
            <template v-slot="scope">
              {{
                  scope.row.last_name
                    ? convertToUppercase(scope.row.last_name)
                    : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column label="User Type" width="165" prop="user_type">
            <template v-slot="scope">
              {{ scope.row.user_type.split("_").join(" ") }}
            </template>
          </el-table-column>
          <el-table-column label="Designation" width="205" prop="designation">
          </el-table-column>
          <el-table-column label="status" width="165" prop="status">
            <template #default="scope">
              <div class="column-status">
                <span class="el-dropdown-link">
                  <el-tag :type="getStatusType(scope.row.status)"
                    >{{ scope.row.status }}
                  </el-tag>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Phone" width="165" prop="phone">
          </el-table-column>
          <el-table-column label="Email" width="205" prop="email">
          </el-table-column>
          <el-table-column label="Actions" width="100" fixed="right">
            <template v-slot="scope">
              <ul class="listings__action-buttons">
                <li>
                  <el-button
                    title="Reset password"
                    @click="onPasswordReset(scope.row)"
                    class="view-button"
                  >
                    <img
                      class="action-active"
                      src="@/assets/images/icons/actions/reset-active.svg"
                      alt="icon"
                    />
                    <img
                      class="action-inactive"
                      src="@/assets/images/icons/actions/reset-deactive.svg"
                      alt="icon"
                    />
                  </el-button>
                </li>
                <li v-if="hasPermission('user_accounts', 'add')">
                  <el-button
                    title="Edit"
                    @click="onEdit(scope.row)"
                    class="view-button"
                    disabled
                  >
                    <img
                      class="action-active"
                      src="@/assets/images/icons/actions/edit-active.svg"
                      alt="icon"
                    />
                    <img
                      class="action-inactive"
                      src="@/assets/images/icons/actions/edit-deactive.svg"
                      alt="icon"
                    />
                  </el-button>
                </li>
              </ul>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="listings listings__pagination">
      <el-pagination
        v-model:currentPage="page"
        v-model:page-size="pageSize"
        :page-sizes="[20, 25, 50, 100]"
        layout=" prev, pager, next, jumper, sizes ,total"
        :total="adminsData.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <div class="default-modal">
      <div v-if="SuccessPopup">
        <el-dialog top="15%" width="30%" v-model="SuccessPopup">
          <div class="popup-date pb-0">
            <div class="text-center">
              <img
                src="@/assets/images/icons/cases/success-popup-icon.svg"
                alt="icon"
              />
            </div>
            <div class="text-center mt-25">
              User Password reset Successfully! <br />
              User will recieve Email with new password !
            </div>
            <div class="dialog-footer justify-center">
              <el-button class="blue-save-button" @click="SuccessPopup = false">
                OK
              </el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [UserPermissionsHelper],
  data() {
    return {
      SuccessPopup: false,
      page: 1,
      loading: false,
      adminsData: [],
      pageSize: 10,
      orderBy: "",
      orderType: "",
      pageSizes: [10, 15, 20],
      hospitalId: this.$route.params.hospital_id,
    };
  },
  computed: {
    ...mapGetters("userAccounts", [
      "getUserAccountDeleteStatus",
      "getUserPasswordResetStatus",
      "getUserAccountErrors",
    ]),
    ...mapGetters("hospitals", ["getAllHospitalAdmins"]),

    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "INACTIVE") {
          return "danger";
        } else {
          return "";
        }
      };
    },
  },
  async mounted() {
    this.fetchHospitalAdmins();
  },
  methods: {
    onPasswordReset(user) {
      let userId = user._id;
      let userName = user.first_name + " " + user.last_name;

      this.$confirm(
        `Are you sure want to  Reset <b>${
          userName || "User"
        }</b> 's Password. Continue ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(async () => {
        await this.resetPassword(userId);
      });
    },
    async resetPassword(id) {
      try {
        this.loading = true;
        let params = {
          id,
        };
        await this.$store.dispatch(
          "userAccounts/resetUserAccountPassword",
          params
        );
        this.loading = false;
        if (this.getUserPasswordResetStatus) {
          this.SuccessPopup = true;
        } else if (this.getUserAccountErrors) {
          this.$notify.error({
            title: "Error",
            message: this.getUserAccountErrors.critical_error,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async onEdit(id) {
      this.$router.push({
        name: "EditHospitalAdmin",
        params: {
          user_id: id._id,
        },
        query: this.$route.query,
      });
    },
    async onDelete(id) {
      this.$confirm("Are you sure to delete Facility Admin?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.deleteAccountManager(id);
      });
    },
    async deleteAccountManager(id) {
      let params = {
        id: id,
      };
      await this.$store.dispatch("userAccounts/deleteUserAccount", params);
      if (this.getUserAccountDeleteStatus) {
        successNotification("Hospital Admin deleted successfully");
        this.loading = true;
        await this.fetchHospitalAdmins();
        this.loading = false;
      } else {
        errorNotification("Error while deleting Hospital Admin");
      }
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchHospitalAdmins();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchHospitalAdmins();
    },
    async fetchHospitalAdmins() {
      this.loading = true;
      let params = {
        page: this.page,
        limit: this.pageSize,
        order_by: this.orderBy || "updated_at",
        order_type: this.orderType || "desc",
        hospital_id: this.hospitalId,
        get_all: true,
      };

      await this.$store.dispatch("hospitals/fetchAllHospitalAdmins", params);
      this.adminsData = this.getAllHospitalAdmins;
      this.loading = false;
    },
  },
};
</script>
